import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { uuidResponseSchema } from '../types';

export type WithdrawCashdeskMutationParams = {
	cashdeskId: number;
	amount: number;
	note?: string;
};

export const createWithdrawCashdeskMutation = () =>
	createAuthMutation({
		params: declareParams<WithdrawCashdeskMutationParams>(),
		request: {
			method: 'POST',
			url: '/cashdesk/withdraw',
			body: (data) => data,
		},
		response: {
			contract: zodContract(uuidResponseSchema),
		},
	});
